import React from 'react';
import NumberFormat from 'react-number-format';

const MAX_TIP = 999999;

export const numberToCurrency = value => (
  <NumberFormat
    value={value}
    prefix="$"
    decimalScale={2}
    fixedDecimalScale
    thousandSeparator=","
    decimalSeparator="."
    displayType="text"
  />
);

export const isInvalidValue = value => value && value > MAX_TIP;
